export default __webpack_public_path__ + "994916616f6dbe7649f7ce71724ec59e.svg";